import React from 'react'
import FaxAgentDashboard from './FaxAgentDashboard'

const FaxAgent = () => {
  return <FaxAgentDashboard />
}

export default FaxAgent;